import OwlCarousel from 'react-owl-carousel';  
import 'owl.carousel/dist/assets/owl.carousel.css';  
import 'owl.carousel/dist/assets/owl.theme.default.css';  

import slider_1 from '../../img/Slider_1.png'
import slider_2 from '../../img/Slider_2.png'
import slider_3 from '../../img/Slider_3.png'
import slider_4 from '../../img/Slider_4.png'

const S2_home = () => {

const options = {
    margin: 30,
    responsiveClass: true,
    nav: true,
    dots: false,
    loop:true,
    autoplay: true,
    navText:['<i class="fa-solid fa-angle-left"></i>','<i class="fa-solid fa-angle-right"></i>'],
    smartSpeed: 1000,
    responsive: {
        0: {
            items: 2,
        },
        400: {
            items: 2,
        },
        600: {
            items: 4,
        },
        700: {
            items: 4,
        },
        1000: {
            items: 5,

        }
    },
};


  return (
<div className='S2_home'>
      <div className='container'>
      <OwlCarousel className="owl-theme" {...options}>



    <div className='item' >  
       <img src={slider_1} alt='Slider_img'/>

    </div>  

    <div className='item' >  
       <img src={slider_2} alt='Slider_img'/>

    </div>        
  
    <div className='item' >  
       <img src={slider_3} alt='Slider_img'/>

      </div>  
      
    <div className='item' >  
       <img src={slider_4} alt='Slider_img'/>

      </div>  

    <div className='item' >  
       <img src={slider_1} alt='Slider_img'/>

      </div>      


</OwlCarousel> 
</div>

</div>
  )
}

export default S2_home